import { Box, IconButton, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import TrendingCol from "../../../Trending";

import { ArrowBackButtonIcon } from "../../assets/icons/entity-icons";

import TestimonialsList from "./TestimonialsList";

const PersonaFullTestimonials = () => {
  const { t } = useTranslation("profiles", { keyPrefix: "testimonials" });
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <Box sx={{ display: "flex", gap: "16px" }}>
      <Box
        sx={{
          display: "flex",
          padding: "20px",
          flexDirection: "column",
          borderRadius: "8px",
          border: "1px solid #EAECF0",
          background: "var(--White, #FFF)",
          width: { xs: "100%", lg: "553px" },
          gap: "16px",
        }}
      >
        <Typography
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            color: "var(--black-100, #1C1C1C)",
            fontFamily: "Montserrat",
            fontSize: "20px",
            fontStyle: "normal",
            fontWeight: 800,
            lineHeight: "normal",
          }}
        >
          <IconButton size="small" onClick={handleBack}>
            <ArrowBackButtonIcon />
          </IconButton>
          {t("testimonials")}
        </Typography>
        <TestimonialsList />
      </Box>
      <Box sx={{ display: { xs: "none", lg: "block" } }}>
        <TrendingCol />
      </Box>
    </Box>
  );
};

export default PersonaFullTestimonials;
